import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

type RootLayoutProps = {
  firstAppPath?: string;
};

/**
 * Root layout component that handles initial app routing and delegation.
 *
 * Redirects users from the root path ("/") to the first available app,
 * then renders the selected app component. Acts as the entry point for
 * the multi-app system routing delegation.
 */
export function RootLayout({ firstAppPath }: RootLayoutProps) {
  const loc = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (loc.pathname === "/" && firstAppPath) {
      navigate(firstAppPath);
    }
  }, [loc.pathname, navigate, firstAppPath]);

  return <Outlet />;
}
